// extracted by mini-css-extract-plugin
export default {"more":"zegoMore_more__1N8dj"};